import React from 'react'
import PropTypes from 'prop-types'

import intl from 'react-intl-universal'

import storage from 'utils/storage'
import { branch } from 'baobab-react/higher-order'

import filter from 'lodash/filter'
import isEmpty from 'lodash/isEmpty'
import orderBy from 'lodash/orderBy'

import { Modal, ModalBody } from 'components/qstrap'
import Button from 'components/atoms/Button'
import SignIn from 'components/authentication/forms/SignIn'
import CardContainer from 'components/authentication/CardContainer'

import triggerEvent from 'utils/dataLayer'

import BannerItem from 'components/molecules/BannerItem'
import BannerPlaceholder from 'components/molecules/BannerPlaceholder'
import ActionTypeProp from 'utils/prop_types/ActionTypeProp'

export class BannerList extends React.Component {
  constructor(props) {
    super(props)

    this.sortedBanners = orderBy(this.props.banners, ['size'], ['asc'])
    this.state = {
      modal: false,
      loginSuccessUrl: '/',
    }

    const filledSpace = (filter(this.props.banners, { size: 'small' }).length % 3) || 3
    this.emptySpaceCount = 3 - filledSpace
    this.checkCurrentUser = this.checkCurrentUser.bind(this)
    this.toggleModal = this.toggleModal.bind(this)
    this.bannersExist = this.bannersExist.bind(this)
    this.handleBannerClick = this.handleBannerClick.bind(this)
    this.handleBannerPlaceholderClick = this.handleBannerPlaceholderClick.bind(this)
  }

  bannersExist() {
    return !isEmpty(this.props.banners)
  }

  checkCurrentUser(e, banner, index) {
    const { currentUser } = this.props

    if (!banner.record_lead) {
      this.handleBannerClick(banner, index)
    } else if (currentUser) {
      if (!currentUser.agreed_to_campus_terms) {
        storage.set('vpMetaNotice', true)
      } else if (!currentUser.vp_meta) {
        window.location.href = `/signup/application?successUrl=${encodeURIComponent(window.location.pathname)}`
        e.preventDefault()
      } else {
        this.handleBannerClick(banner, index)
      }
    } else {
      this.toggleModal()
      e.preventDefault()
    }
  }

  toggleModal() {
    this.setState({ modal: !this.state.modal })
  }

  handleBannerClick(banner, index) {
    const { banners, type, schoolName, schoolSlug } = this.props
    const prefixEvent = 'ga/home/bannerads/'
    let eventName = 'bigbanner'

    if (banner.size === 'small') {
      const bigBannerCount = filter(banners, { size: 'big' }).length
      eventName = 'smallbanner-'

      switch (index) {
        case bigBannerCount:
          eventName += 'left'
          break
        case bigBannerCount + 1:
          eventName += 'middle'
          break
        case bigBannerCount + 2:
          eventName += 'right'
          break
        default:
      }
    }

    if (type) {
      if (type === 'campus') {
        triggerEvent('campus_banner', {
          campus_name: schoolName,
          page_location: `/directory/${schoolSlug}`,
          banner_name: banner.name
        })
      } else {
        triggerEvent(`ga/${type}/banner-promotion/${banner.name}`)
      }
    } else {
      triggerEvent(`${prefixEvent}${eventName}`, {
        name: banner.name,
      })
    }
  }

  handleBannerPlaceholderClick(e, index) {
    if (this.emptySpaceCount === 2 && index === 0) {
      triggerEvent('ga/home/bannerads/smallbanner-middle')
    } else {
      triggerEvent('ga/home/bannerads/smallbanner-right')
    }
  }

  render() {
    const { homepage, usePlaceholder } = this.props
    if (this.bannersExist()) {
      return (
        <div id="banner-list">
          { homepage && <div className="title">{intl.get('banner_title')}</div> }

          {this.sortedBanners.map((banner, index) =>
            <BannerItem key={index} banner={banner} onClick={e => this.checkCurrentUser(e, banner, index)} />
          )}

          {usePlaceholder && [...Array(this.emptySpaceCount)].map((val, index) =>
            <BannerPlaceholder key={index} number={index} onClick={e => this.handleBannerPlaceholderClick(e, index)} />
          )}

          { (homepage && this.sortedBanners.length > 0) && (
            <div className="more-partners">
              <Button className="more-partners__link" href="/partners">Lihat Informasi Lainnya</Button>
            </div>
          )}

          <Modal autoFocus={false} isOpen={this.state.modal} fade={false} toggle={this.toggleModal} className="AuthenticatedLinkModal">
            <ModalBody>
              <CardContainer>
                <div className="external-container text-center container">
                  <SignIn successUrl={this.state.loginSuccessUrl} />
                </div>
              </CardContainer>
            </ModalBody>
          </Modal>

          <style jsx>
            {`
              #banner-list {
                ${!homepage ? 'padding-top: 80px; padding-bottom: 0;' : ''}
              }
              .more-partners {
                :global(.more-partners__link) {
                  margin-top: 32px;
                  font-size: 16px;
                  font-weight: 700;
                }
              }
            `}
          </style>
        </div>
      )
    }
    return null
  }
}

BannerList.propTypes = {
  banners: PropTypes.arrayOf(PropTypes.object),
  schoolSlug: PropTypes.string,
  schoolName: PropTypes.string,
  currentUser: PropTypes.object,
  homepage: PropTypes.bool,
  usePlaceholder: PropTypes.bool,
  type: ActionTypeProp,
}

BannerList.defaultProps = {
  banners: [],
  usePlaceholder: true,
}

export default branch({
  currentUser: ['serverProps', 'currentUser'],
  schoolSlug: ['serverProps', 'school', 'slug'],
  schoolName: ['serverProps', 'school', 'name'],
}, BannerList)
